import Vue from 'vue'
import Router from 'vue-router'
import Front from '@/pages/Front'
import ArtistLP from '@/pages/ArtistLP'
import Login from '@/pages/Login'
import RegisterConfirm from '@/pages/RegisterConfirm'
import Msie from '@/pages/Msie'
import ModalDev from '@/pages/ModalDev'
import HomeIndex from '@/pages/home/HomeIndex'
import About from '@/pages/home/About'
import Agreement from '@/pages/home/Agreement'
import Policy from '@/pages/home/Policy'
import Faq from '@/pages/home/Faq'
import Contact from '@/pages/home/Contact'
import PlayList from '@/pages/home/PlayList'
import Favorite from '@/pages/home/Favorite'
import Recommended from '@/pages/home/recommended/Index'
import RecommendedDetail from '@/pages/home/recommended/RecommendedDetail'
import Artist from '@/pages/home/artist/Index'
import Detail from '@/pages/home/artist/Detail'
import Info from '@/pages/home/Info'
import Search from '@/pages/home/Search'
import Ranking from '@/pages/home/Ranking'
import ApiTest from '@/pages/apiTest'
import UserService from '@/components/services/UserService.vue'

import store from '../store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/modaldev',
      name: 'ModalDev',
      component: ModalDev
    },
    {
      path: '/',
      name: 'Front',
      component: Front
    },
    {
      path: '/artist',
      name: 'ArtistLP',
      component: ArtistLP
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register-confirm',
      name: 'RegisterConfirm',
      component: RegisterConfirm
    },
    {
      path: '/msie',
      name: 'Msie',
      component: Msie
    },
    {
      path: '/home',
      component: HomeIndex,
      children: [
        {
          path: '/home/about',
          name: 'About',
          component: About
        },
        {
          path: '/home/agreement',
          name: 'Agreement',
          component: Agreement
        },
        {
          path: '/home/policy',
          name: 'Policy',
          component: Policy
        },
        {
          path: '/home/faq',
          name: 'Faq',
          component: Faq
        },
        {
          path: '/home/contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/home/info',
          name: 'Info',
          component: Info
        },
        {
          path: '/home/playlist',
          name: 'PlayList',
          component: PlayList
        },
        {
          path: '/home/favorite',
          name: 'Favorite',
          component: Favorite
        },
        {
          path: '/home/ranking',
          name: 'Ranking',
          component: Ranking
        },
        {
          path: '/home/recommended',
          name: 'Recommended',
          component: Recommended
        },
        {
          path: '/home/recommended/detail/:id',
          name: 'RecommendedDetail',
          component: RecommendedDetail
        },
        {
          path: '/home/artist',
          name: 'Artist',
          component: Artist
        },
        {
          path: '/home/artist/detail/:id',
          name: 'Detail',
          component: Detail
        },
        {
          path: '/home/search',
          name: 'Search',
          component: Search
        }
      ],
      // メタフィールド
      meta: { requiresAuth: true }
    },
    {
      path: '/api-test',
      name: 'APiTest',
      component: ApiTest
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      sessionStorage.setItem('positionY', savedPosition.y)
      return savedPosition
    } else {
      sessionStorage.setItem('positionY', 0)
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // transactionIdを持っていない場合、ログインページにリダイレクトします。
    var transactionId = store.getters.checkTransactionId
    UserService.logined(transactionId, (response) => {
      if (response === undefined) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }, (error) => {
      console.log(error)
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js